// This is a helper script to load embedded scripts from html text that is appended into the DOM
export default function loadEmbeddedScripts(htmlText: string): void {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlText;
    const scripts = tempDiv.querySelectorAll('script[type="module"]');

    // Load each script by creating a new script element and appending it to the body
    scripts.forEach((script, it) => {
        const src = script.getAttribute('src');
        if (src) {
            const scriptTag = document.createElement('script');
            scriptTag.async = true;
            scriptTag.type = 'module';
            scriptTag.src = src + "?" + it; // this way a script can be imported and executed multiple times
            document.body.appendChild(scriptTag);
            document.body.removeChild(scriptTag);
        }
    });
}
